module.exports = __webpack_public_path__ + "img/partner7.0269cec6.png";